interface DrawerProps {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const Drawer = ({ children, open, onOpenChange }: DrawerProps) => {
  return (
    <div
      className={`fixed inset-0 z-50 bg-gray-500/50 flex items-end justify-center transition-opacity duration-200 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      onClick={() => onOpenChange(false)}
    >
      <div className="w-full bg-white rounded-t-lg p-4" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
};
